export default "__VITE_ASSET__sqM9Fuse__"